/**
 * Created by tofaelraju on 10/15/17.
 */

import ajax from './ajax';
import {Map} from 'immutable';

const {request, submitForm} = ajax;

const getAdmins = () => {
  return request({
    url: 'admins',
    method: 'get'
  });
};

const getDoctors = () => {
  return request({
    url: 'doctors/approved',
    method: 'get'
  });
};

const getAttendances = (id, start, end) => {
  return request({
    url: `attendance/${id}?start_time=${parseLocalDate(start).toISOString()}&end_time=${parseLocalDate(end).toISOString()}`,
    method: 'get'
  });
};

const getConsumers = () => {
  return request({
    url: 'consumers',
    method: 'get'
  });
};

const getOperators = () => {
  return request({
    url: 'doctors/operators',
    method: 'get'
  });
};

const getAvailableOperators = () => {
  return request({
    url: 'operators/available',
    method: 'get'
  })
  .then((result) => {
    let operatorMap = Map();
    result.forEach((operator) => {
      operatorMap = operatorMap.set(operator.id, operator);
    });
    return operatorMap;
  })
  .catch((error) => {
    throw error;
  })
};

const getPendingPayments = () => {
  return request({
      url: 'missions/billed',
      method: 'GET'
    })
    .then((result) => {
      let billedPayments = Map();
      result.forEach((mission) => {
        billedPayments = billedPayments.set(mission.id, mission);
      });
      return billedPayments;
    })
    .catch((error) => {
      throw error;
    })
}

const manualPayment = (missionId, amount, medium, fromPhone, notes) => {
  return request({
      url:'payment/actions/add/by-operations',
      method: 'POST',
      body: {
        missionId: missionId,
        amount: amount,
        medium: medium,
        fromPhone: fromPhone,
        notes: notes
      }
    })
    .catch((error) => {
      throw error;
    })
}

const getVisitingDoctors = () => {
  return request({
    url: 'doctors/available',
    method: 'get'
  })
  .then((result) => {
    let doctorMap = Map();
    result.forEach((doctor) => {
      doctorMap = doctorMap.set(doctor.id, doctor);
    });
    return doctorMap;
  })
  .catch((error) => {
    throw error;
  })
};

function parseLocalDate(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

const getMissions = (startDate, endDate, doctorName, operatorName, patientName, callerPhone, missionNumber, symptom, counselling, covidRelated, role) => {
  const params = [];

  if(role) {
    params.push(`role=${role}`);
  }

  if (startDate && endDate) {
    params.push(`startDate=${parseLocalDate(startDate).toISOString()}`);
    params.push(`endDate=${parseLocalDate(endDate).toISOString()}`);
  }

  if (doctorName) {
    params.push(`doctorName=${doctorName}`);
  }
  if (operatorName) {
    params.push(`operatorName=${operatorName}`);
  }
  if (patientName) {
    params.push(`patientName=${patientName}`)
  }
  if (callerPhone) {
    params.push(`callerPhone=${callerPhone}`)
  }
  if (missionNumber) {
    params.push(`missionNumber=${missionNumber}`)
  }
  if (symptom) {
    params.push(`symptom=${symptom}`)
  }
  if (counselling) {
    params.push(`counselling=${counselling}`)
  }
  if (covidRelated) {
    params.push(`covidRelated=${covidRelated}`)
  }
  

  const url = (params.length > 0) ? `missions?${params.join('&')}` : 'missions';

  return request({
    url,
    method: 'get'
  });
};

const getOptimizedCallRequests = (startDate, endDate, operatorName, callerName, patientName, callerPhone) => {
  const params = [];

  if (startDate && endDate) {
    params.push(`startDate=${parseLocalDate(startDate).toISOString()}`);
    params.push(`endDate=${parseLocalDate(endDate).toISOString()}`);
  }

  if (operatorName) {
    params.push(`operatorName=${operatorName}`);
  }
  if (callerName) {
    params.push(`callerName=${callerName}`);
  }
  if (patientName) {
    params.push(`patientName=${patientName}`)
  }
  if (callerPhone) {
    params.push(`callerPhone=${callerPhone}`)
  }
  const url = (params.length > 0) ? `call-requests/pagination?${params.join('&')}` : 'call-requests/pagination';

  return request({
    url,
    method: 'get'
  });

}

const getStats = (fromDate, toDate) => {
  return request({
    url: `stats/${fromDate}/${toDate}`,
    method: 'get'
  });
};

const getPendingApplications = () => {
  return request({
    url: 'doctors/pending',
    method: 'get'
  });
};

const getCallRequests = (limit, offset) => {
  return request({
    url: `call-requests/pagination?limit=${limit}&offset=${offset}`,
    method: 'get'
  });
};

const resetPassword = (userId) => {
  return request({
    url: 'users/actions/resend-credentials',
    method: 'post',
    body: {
      userId: userId
    }
  });
};

const updateDoctorStatus = (adminUserId, doctorId, status, comment) => {
  return request({
    url: 'doctors/actions/update-status',
    method: 'post',
    body: {
      adminUserId: adminUserId,
      doctorId: doctorId,
      status: status,
      comment: comment
    }
  });
};

const submitSchedule = (body) => {
  return request({
    url: 'schedule',
    method: 'post',
    body
  });
};

const deleteSchedule =(scheduleId)=>{
  return request({
    url: 'schedule/' + scheduleId,
    method: 'delete'
  })
};

const getDoctor =(id)=>{
  return request({
    url: 'doctor/' + id,
    method: 'get'
  })
};

const getUser =(id)=>{
  return request({
    url: 'operators/' + id,
    method: 'get'
  })
};

const getUserPatients =(id)=>{
  return request({
    url: 'users/' + id+'/patients',
    method: 'get'
  })
};

const createDoctor=(data)=>{
  return request({
    url: 'doctors',
    method: 'post',
    body: data
  });
};

const updateDoctorPhoto=(data)=>{
  return submitForm({
    url: 'doctor/photo',
    data
  });
};

const updateAdminPhoto=(data)=>{
  return submitForm({
    url: 'admin/photo',
    data
  });
};

const updateDoctorProfile=(data)=>{
  return request({
    url: 'doctors',
    method: 'put',
    body: data
  });
};

const createUser=(data)=>{
  return request({
    url: 'admins',
    method: 'post',
    body: data
  });
};

const updateUserProfile=(data)=>{
  return request({
    url: 'users/actions/update-profile',
    method: 'post',
    body: data
  });
};

const updateRole=(data)=>{
  return request({
    url: 'users/actions/update-admin-privileges',
    method: 'post',
    body: data
  });
};

const login=(username, password)=>{
  return request({
    url: 'users/actions/login',
    method: 'post',
    body: {
      username,
      password
    }
  });
};

const logout=()=>{
  return request({
    url: 'users/actions/logout',
    method: 'post'
  });
};

const lockUser=(userId)=>{
  return request({
    url: 'users/actions/lock',
    method: 'post',
    body: {
      userId: userId
    }
  });
};

const unlockUser=(userId)=>{
  return request({
    url: 'users/actions/unlock',
    method: 'post',
    body: {
      userId: userId
    }
  });
};

const toggleEmailReceiverFlag=(userId)=>{
  return request({
    url: 'users/actions/toggle-email-receiver-flag',
    method: 'post',
    body: {
      userId: userId
    }
  });
};

const getOperatingHour =()=>{
  return request({
      url: 'appointment/operating-hour',
      method: 'get'
    });
};

const updateSipCredentials =(doctorId, sipId, sipPassword)=>{
  return request({
    url: 'doctors/actions/set-sip-credential',
    method: 'post',
    body: {
      sipId,
      doctorId,
      sipPassword
    }
  });
};

const reopenMission =(missionId, comment)=>{
  return request({
    url: 'mission/actions/reopen',
    method: 'post',
    body: {
      missionId,
      comment
    }
  });
};

const endMission =(missionId, comment)=>{
  return request({
    url: 'mission/actions/done',
    method: 'POST',
    body: {
      missionId: missionId,
      comment
    }
  });
};

const getMissionDetails =(missionId)=>{
  return request({
    url: `mission/${missionId}`,
    method: 'get'
  });
};

const uploadMissionReport=(data)=>{
  return submitForm({
    url: 'mission/actions/upload-inv-report',
    data
  });
};

const uploadPrescriptionFile=(data)=>{
  return submitForm({
    url: 'mission/actions/upload-prescription-file',
    data
  });
};

const deleteMissionInvestigationReport=(reportId)=>{
  return request({
    url: 'mission/actions/delete-inv-report',
    method: 'POST',
    body: {
      investigationReportId: reportId
    }
  });
};

const getMissionActivity =(missionId)=>{
  return request({
    url: `activities/mission/${missionId}`,
    method: 'get'
  });
};

const getCallActivity =(callId)=>{
  return request({
    url: `activities/call-requests/${callId}`,
    method: 'get'
  });
};

function submitMissionReview(missionId, review) {
  return (
    request({
      url: 'mission/review',
      method: 'POST',
      body: {
        comment: review,
        missionId: missionId
      }
    })
      .catch((error) => {
        throw error;
      })
  );
}

function getCallInfoSourceList() {
  return (
    request({
      url: `sources`,
      method: 'GET'
    })
      .catch((err) => {
        throw err;
      })
  );
}

function getDoctorSchedule(date) {
  return (
    request({
      url: 'schedule/date/'+date,
      method: 'get'
    })
    .then(data=>{
      let schedulesMap = Map();
      data.schedules.forEach((doctorWithSchedule) => {
        schedulesMap = schedulesMap.set(doctorWithSchedule.id, doctorWithSchedule);
      });
      let appointmentsMap = Map();
      data.appointments.forEach((appointment) => {
        appointmentsMap = appointmentsMap.set(appointment.group, appointment);
      });
      return {schedules: schedulesMap, appointments: appointmentsMap};
    })
  );
}

const toggleTestMissionFlag =(missionId)=>{
  return request({
    url: 'mission/actions/toggle-test-mark',
    method: 'post',
    body: {
      missionId
    }
  });
};

const toggleTestCallFlag =(requestId)=>{
  return request({
    url: 'call-requests/actions/toggle-test-mark',
    method: 'post',
    body: {
      requestId
    }
  });
};

const createTip = (data) => {
  return request({
    url: 'app-tips',
    method: 'post',
    body: data
  });
};

const getTips = () => {
  return request({
    url: 'app-tips',
    method: 'get',
  })
}

let getAppointmentsByDate = (date) => {
  return request({
    url: 'appointment/date/'+date,
    method: 'get'
  })
}

const rescheduleAppointment = (appointmentId, start_time, end_time, missionId, doctorId, operatorId) => {
  return request({
    url: 'reschedule-appointment',
    method: 'post',
    body: {
      appointmentId,
      start_time,
      end_time,
      missionId,
      doctorId,
      operatorId
    }
  });

}
const getSpecialities = () => {
  return request({
    url: 'doctors/specialities',
    method: 'get',
  })
};

const createSpeciality = (data) => {
  return request({
    url: 'doctors/specialities',
    method: 'post',
    body: data
  });
};

const updateSpecialityInfo = (specialityId, specialityTitle) => {
  return request({
    url: 'doctors/specialities/update',
    method: 'post',
    body: {
      specialityId,
      specialityTitle
    }
  });
};

const startMissionInvestigation = (missionId) => {
  return request({
    url: 'mission/actions/start-investigation',
    method: 'post',
    body: {
      missionId
    }
  })
}

const endMissionInvestigation = (missionId) => {
  return request({
    url: 'mission/actions/finish-visit',
    method: 'post',
    body: {
      missionId
    }
  })
}


export default {
  login,
  logout,
  getTips,
  getUser,
  getStats,
  lockUser,
  createTip,
  getDoctor,
  getAdmins,
  unlockUser,
  updateRole,
  getDoctors,
  endMission,
  createUser,
  getMissions,
  getOperators,
  createDoctor,
  getConsumers,
  manualPayment,
  resetPassword,
  reopenMission,
  getAttendances,
  submitSchedule,
  deleteSchedule,
  getUserPatients,
  getCallActivity,
  getCallRequests,
  getOperatingHour,
  getMissionDetails,
  updateUserProfile,
  getPendingPayments,
  getVisitingDoctors,
  updateDoctorStatus,
  updateAdminPhoto,
  getDoctorSchedule,
  updateDoctorPhoto,
  getMissionActivity,
  toggleTestCallFlag,
  submitMissionReview,
  updateDoctorProfile,
  uploadPrescriptionFile,
  uploadMissionReport,
  updateSipCredentials,
  getAvailableOperators,
  getCallInfoSourceList,
  toggleTestMissionFlag,
  getPendingApplications,
  toggleEmailReceiverFlag,
  getOptimizedCallRequests,
  deleteMissionInvestigationReport,
  getAppointmentsByDate,
  rescheduleAppointment,
  getSpecialities,
  createSpeciality,
  updateSpecialityInfo,
  startMissionInvestigation,
  endMissionInvestigation
}



// WEBPACK FOOTER //
// ./src/utility/api.js